const menus = [
  {
    id: 1,
    name_es: "Nosotros",
    name_en: "About",
    links: "/about",
  },
  {
    id: 2,
    name_es: "Servicios",
    links: "/service",
  },
  {
    id: 3,
    name_es: "Contacto",
    links: "/contact",
  },
];

export default menus;
